module.exports = __webpack_public_path__ + "static/media/loads.ea9ccc78.svg";